import React, { useState, useEffect, useRef } from "react";
import { Formik, useFormik } from "formik";

import * as Yup from "yup";
import BestPlaceForm from "./BestPlace/BestPlaceForm";

const placeScheme = Yup.object().shape({
  region_id: Yup.string().required("Required"),
  listing_id: Yup.string().required("Required"),
  title: Yup.string().required("Required"),
  highlight: Yup.string().required("Required"),
  excerpt: Yup.string().required("Required"),
});

const BestPlaceEdit = (props) => {
  const { best_place } = props;
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef();

  console.log("BestPlaceEdit", props);
  const handleSave = (data) => {
    console.log("savesave", data);

    setIsLoading(true);
    fetch(`/admin/best_places/${best_place.id}.json`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
      body: JSON.stringify({ best_place: { ...data } }),
    })
      .then((resp) => {
        return resp.json();
      })
      .then((resp) => {
        console.log("resp", resp);
        setIsLoading(false);
        window.location.href = `/admin/best_places/${resp.resource.id}`;
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      ...(best_place || {}),
    },
    validationSchema: placeScheme, // replace with your actual validation schema
    onSubmit: handleSave, // replace with your form submission function
  });

  const {
    handleSubmit,
  } = formik;


  return (
    <React.Fragment>
      <form onSubmit={handleSubmit} ref={formRef}>
        <BestPlaceForm
          formik={formik}
        />
        <div className={`form-action`}>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            Save &amp; Edit
          </button>
        </div>
      </form>

    </React.Fragment>
  );
};

export default BestPlaceEdit;
